import { BaseTranslation } from 'src/i18n/i18n-types';

export const profileSettings: BaseTranslation = {
  yourProfile: 'Your Profile',
  yourProfileDescription:
    'This information will be displayed to other users so be careful what you share.',
  changeEmail: 'Change Email',
  googleAccount: 'Google Account',
  errors: {
    nameRequired: 'A name is required.',
    emailRequired: 'An email address is required.',
  },
  success: {
    emailChangedDetail:
      "We've sent a verification email to {email}. Your account's email will be updated once it is verfied.",
    emailChanged:
      'Verification email sent. Your email address will be updated once the verification link in the email is opened.',
  },
  notificationSettings: {
    title: 'Notifications',
    subtitle: 'Control your email notification settings.',
    update: {
      success: 'Successfully updated user notification settings',
      error: 'Error updating notification settings: {error}',
    },
    personalPreferences: 'Personal Preferences',
    personalPreferencesDescription:
      'We’ll always let you know about important changes, but you pick what else you want to hear about.',
    comments: 'Comments',
    commentsDescription:
      'Get notified when someone posts a comment on a posting.',
    mentions: 'Mentions',
    mentionsDescription: 'Get notified when someone mentions you.',
    briefsNotificationsDescription:
      'These alerts appear within the platform for the Brief feature.',
    assignmentChange: 'Assignment Change',
    assignmentChangeDescription:
      'Get notified when the assigned member of a brief is changed.',
    dueDateChange: 'Due Date Change',
    dueDateChangeDescription:
      'Get notified when the due date of a brief is changed.',
    stageChange: 'Stage Change',
    stageChangeDescription:
      'Get notified when there is a change in the progress of a brief.',
    statusChange: 'Status Change',
    statusChangeDescription: 'Get notified when the status of a brief changes.',
    allNotifications: 'All notifications',
    allNotificationsLabel: 'Turn on/off all notifications.',
    allNotificationsDescription:
      'Enable or disable all notifications you receive via email.',
  },
  personalSettings: 'Personal settings',
  yourPersonalInformation:
    'Your personal information and account security settings.',
  accountDetails: 'Account Details',
  personalProfile: 'Personal Profile',
  updateDetails: 'Update Details',
  profilePicture: 'Profile Picture',
  fullName: 'Full Name',
  email: 'Email',
  role: 'Role',
  industry: 'Industry',
};
